export const ACTION_BAR_SET_SELECTED_OUTLET_IDS =
  'ACTION_BAR_SET_SELECTED_OUTLET_IDS';

export const ACTION_BAR_SET_OUTLETS = 'ACTION_BAR_SET_OUTLETS';
